export default __webpack_public_path__ + "static/media/q7_03.a4319b8b.jpg";